<template>
  <div></div>
</template>

<script>
export default {
  name: 'Play',
  data() {
    return {
      EXAM_CODE: '',
      YBMRESULT: '',
    };
  },
  async mounted() {
    await this.setting();
    window.onbeforeunload = function() {
      window.opener.postMessage('close', '*');
    };

    close();
  },
  methods: {
    setting: function() {
      /* get URL의 파라미터 분리 */
      let encodedUrl = window.location.search;
      if (encodedUrl != null && encodedUrl != '') {
        let decodedUrl = decodeURIComponent(encodedUrl);
        decodedUrl = this.parseQueryStringDeleteQ(decodedUrl);
        let parsedQuery = this.parseQueryString(decodedUrl);

        this.EXAM_CODE = parsedQuery.EXAM_CODE;
        this.YBMRESULT = parsedQuery.YBMRESULT.split('|');

        let level = 0;
        let date = 1;
        let examNo = '';
        let org = '';

        switch (this.EXAM_CODE) {
          case '1': //TOEIC
            level = 2;
            date = 3;
            examNo = 4;
            org = '한국토익위원회';
            break;
          case '2': //JPT
            level = 2;
            date = 3;
            examNo = 4;
            org = 'YBM';
            break;
          case '5': //TOEIC Speaking Test
            level = 0;
            date = 1;
            examNo = 2;
            org = '한국토익위원회';
            break;
          case '7': //TSC
            level = 0;
            date = 1;
            examNo = 2;
            org = 'YBM';
            break;
          case '8': //SJPT
            level = 0;
            date = 1;
            examNo = 2;
            org = 'YBM';
            break;
          case '10': //TOEIC Writing Test
            level = 0;
            date = 1;
            examNo = 2;
            org = '한국토익위원회';
            break;
        }
        /* 부모창에 데이터 세팅 시험코드, 시험점수/등급, 시험일, 발급번호, 발급기관*/
        /* 이력서 입력 창에 데이터 세팅 */
        if (this.EXAM_CODE == '5') {
          //토익스피킹 레벨의 숫자가 있는경우 공백 제거
          var result = this.YBMRESULT[level].replace(/\s(\d+)/, '$1');
          opener.document.ybmFrm.YBMRESULT_LEVEL.value = result;
        } else {
          opener.document.ybmFrm.YBMRESULT_LEVEL.value = this.YBMRESULT[level];
        }
        opener.document.ybmFrm.EXAMCODE.value = this.EXAM_CODE;
        opener.document.ybmFrm.YBMRESULT_DATE.value = this.YBMRESULT[date];
        opener.document.ybmFrm.YBMRESULT_EXAMNO.value = this.YBMRESULT[examNo];
        opener.document.ybmFrm.YBMRESULT_ORG.value = org;
      }
    },
    parseQueryString(queryString) {
      let result = {};
      let pairs = queryString.split('&');

      pairs.forEach(pair => {
        let keyValue = pair.split('=');
        result[keyValue[0]] = decodeURIComponent(keyValue[1] || '');
      });

      return result;
    },
    parseQueryStringDeleteQ(url) {
      let index = url.indexOf('?');
      if (index !== -1) {
        return url.slice(index + 1);
      }
      return '';
    },
  },
};
</script>
